import { GetDistinctEcrCodesCommand } from "@/model/communication/ecr/GetDistinctEcrCodesCommand";
import { GetDistinctEcrCodesResData } from "@/model/communication/ecr/GetDistinctEcrCodesResData";
import { GetDistinctSensorsDataCommand } from "@/model/communication/ecr/GetDistinctSensorsDataCommand";
import { GetDistinctSensorsDataResData } from "@/model/communication/ecr/GetDistinctSensorsDataResData";
import { GetEcrFileInformationsCommand } from "@/model/communication/ecr/GetEcrFileInformationsCommand";
import { GetEcrFileInformationsResData } from "@/model/communication/ecr/GetEcrFileInformationsResData";
import { UploadEcrFileCommand } from "@/model/communication/ecr/UploadEcrFileCommand";
import { AxiosResponse } from "axios";
import { SET_AVAILABLE_ECR_CODES, SET_AVAILABLE_SENSOR_FIRMWARES, SET_AVAILABLE_SENSOR_MODELS, SET_ECR_FILE_LAST_UPDATE, SET_ECR_FILE_VERSION } from "./mutations";

export const GET_AVAILABLE_ECR_CODES = "GET_AVAILABLE_ECR_CODES";
export const GET_DISTINCT_SENSORS_DATA = "GET_DISTINCT_SENSORS_DATA";
export const GET_ECR_FILE_INFORMATIONS = "GET_ECR_FILE_INFORMATIONS";
export const UPLOAD_ECR_FILE = "UPLOAD_ECR_FILE";

export default {
    async [GET_AVAILABLE_ECR_CODES]({ commit }) {
        let res: GetDistinctEcrCodesResData = await new GetDistinctEcrCodesCommand().execute();
        if (res.ecrCodes.length > 0) commit(SET_AVAILABLE_ECR_CODES, res.ecrCodes);
    },

    async [GET_DISTINCT_SENSORS_DATA]({ commit }) {
        let res: GetDistinctSensorsDataResData = await new GetDistinctSensorsDataCommand().execute();
        if (res.sensorModels.length > 0) commit(SET_AVAILABLE_SENSOR_MODELS, res.sensorModels);
        if (res.sensorFirmwares.length > 0) commit(SET_AVAILABLE_SENSOR_FIRMWARES, res.sensorFirmwares);
    },

    async [GET_ECR_FILE_INFORMATIONS]({ commit }) {
        let res: GetEcrFileInformationsResData = await new GetEcrFileInformationsCommand().execute();
        if (res.version != null) commit(SET_ECR_FILE_VERSION, res.version);
        if (res.lastUpdate != null) commit(SET_ECR_FILE_LAST_UPDATE, res.lastUpdate);
    },

    async [UPLOAD_ECR_FILE]({ commit }, file: any): Promise<AxiosResponse> {
        return await new UploadEcrFileCommand(file).execute();
    },
};
